import React from 'react';
import { calculateWinLoss } from '../../utils/betting';
import './WinLossPopup.css';

function WinLossPopup({ game, userBets, onClose, isOpen }) {
  // Don't render if not open, no game, or no bets
  if (!isOpen || !game || !userBets || userBets.length === 0) {
    return null;
  }

  // Validate game has winner_side and is ended
  if (game.status !== 'ended') {
    console.warn('WinLossPopup: Game is not ended');
    return null;
  }
  
  if (!game.winner_side) {
    console.warn('WinLossPopup: Game has no winner_side');
    return null;
  }

  // Calculate win/loss
  let winLoss;
  try {
    winLoss = calculateWinLoss(userBets, game.winner_side);
  } catch (error) {
    console.error('Error calculating win/loss:', error);
    return null;
  }

  // Get winning team name
  const winningTeamName = game.winner_side === 'yes' 
    ? (game.team_yes_name || 'Yes')
    : (game.team_no_name || 'No');

  // Format payout difference
  const payoutDifference = Math.abs(winLoss.payoutDifference);
  const isWin = winLoss.won;
  const isLoss = !isWin && winLoss.payoutDifference < 0;
  const isBreakEven = winLoss.payoutDifference === 0;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="win-loss-popup-overlay" onClick={handleOverlayClick}>
      <div className="win-loss-popup-container">
        <button className="win-loss-popup-close" onClick={onClose}>×</button>
        
        <div className={`win-loss-popup-content ${isWin ? 'win' : isLoss ? 'loss' : 'break-even'}`}>
          {/* Icon/Emoji */}
          <div className="win-loss-popup-icon">
            {isWin && <span className="win-loss-emoji">🎉</span>}
            {isLoss && <span className="win-loss-emoji">😔</span>}
            {isBreakEven && <span className="win-loss-emoji">🤝</span>}
          </div>

          {/* Title */}
          <h2 className="win-loss-popup-title">
            {isWin && 'Congratulations!'}
            {isLoss && 'Better Luck Next Time!'}
            {isBreakEven && 'Break Even'}
          </h2>

          {/* Message */}
          <p className="win-loss-popup-message">
            {isWin && `You won! Your bets on the winning team paid off.`}
            {isLoss && `Unfortunately, your bets didn't win this time.`}
            {isBreakEven && `Your bets resulted in a break even.`}
          </p>

          {/* Winning Team */}
          <div className="win-loss-popup-team">
            <span className="win-loss-popup-team-label">Winning Team:</span>
            <span className="win-loss-popup-team-name">{winningTeamName}</span>
          </div>

          {/* Payout Difference */}
          <div className="win-loss-popup-amount">
            <span className="win-loss-popup-amount-label">Payout Difference:</span>
            <span className={`win-loss-popup-amount-value ${isWin ? 'positive' : isLoss ? 'negative' : 'neutral'}`}>
              {isWin && '+'}
              {isLoss && '-'}
              ${payoutDifference.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </span>
          </div>

          {/* Additional Stats */}
          <div className="win-loss-popup-stats">
            {winLoss.winningBetsCount > 0 && (
              <div className="win-loss-popup-stat">
                <span>Winning Bets:</span>
                <span>{winLoss.winningBetsCount}</span>
              </div>
            )}
            {winLoss.losingBetsCount > 0 && (
              <div className="win-loss-popup-stat">
                <span>Losing Bets:</span>
                <span>{winLoss.losingBetsCount}</span>
              </div>
            )}
          </div>

          {/* Close Button */}
          <button className="win-loss-popup-button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default WinLossPopup;

